// settings/HamburgerMenu/MenuToggleButton.tsx
import React, { useRef, useEffect } from "react";
import { useAtom } from "jotai";
import { isSettingOpenAtom } from "~/Atom";
import { MenuToggleButtonProps } from "shared/Schemas";

/**
 * 設定メニューを開閉するトグルボタンコンポーネント
 * マウスクリックでメニューの開閉を行う
 */
const MenuToggleButton: React.FC<MenuToggleButtonProps> = ({ onClick, disabled }) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [isSettingOpen] = useAtom(isSettingOpenAtom);

  useEffect(() => {
    /**
     * ポインターイベントのハンドラー
     * マウスクリック時にボタンのクリック状態を切り替える
     */
    const handlePointerDown = (event: PointerEvent) => {
      if (event.pointerType === "mouse") {
        onClick();
        if (buttonRef.current) {
          buttonRef.current.classList.toggle("clicked");
        }
      }
    };

    const buttonElement = buttonRef.current;
    if (buttonElement) {
      buttonElement.removeEventListener("pointerdown", handlePointerDown);
      buttonElement.addEventListener("pointerdown", handlePointerDown);
    }

    return () => {
      if (buttonElement) {
        buttonElement.removeEventListener("pointerdown", handlePointerDown);
      }
    };
  }, [isSettingOpen, onClick]);

  return (
    <button className="setting-button" ref={buttonRef} disabled={disabled}>
      <span className="material-symbols-rounded setting-button">settings</span>
    </button>
  );
};

export default MenuToggleButton;
